import { transformDateValue } from 'core/js/FormUtils';
export const getPharmaorderView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let pharmaorderList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Sub Total","fieldValue":transformDataValue(data.subtotal,"double"), "fieldType":"double"},
                            {"fieldLabel":"GST Amount","fieldValue":transformDataValue(data.gstamount,"double"), "fieldType":"double"},
                            {"fieldLabel":"Advance","fieldValue":transformDataValue(data.advance,"number"), "fieldType":"number"},
                            {"fieldLabel":"Submit Date","fieldValue":transformDataValue(data.submitdate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Delivery Date","fieldValue":transformDataValue(data.deliverydate,"date"), "fieldType":"date"},
                            {"fieldLabel":"Executive Id","fieldValue":transformDataValue(data.executiveid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Order Id","fieldValue":transformDataValue(data.orderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Party Name","fieldValue":transformDataValue(data.partyname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Order Value","fieldValue":transformDataValue(data.ordervalue,"double"), "fieldType":"double"},
                            {"fieldLabel":"Status","fieldValue":transformDataValue(data.orderstatus,"list"), "fieldType":"list"},
              
              
            ],
            'dataList': [
                              {"fieldLabel":"Comment","fieldValue":transformDataValue(data.comment,"string"), "fieldType":"string"},
                            {"fieldLabel":"Executive Name","fieldValue":transformDataValue(data.executivename,"string"), "fieldType":"string"},
                            {"fieldLabel":"Dispatch Date","fieldValue":transformDataValue(data.dispatchdate,"date"), "fieldType":"date"},
              
              ]
          }

          pharmaorderList.push(card);
  })
  return pharmaorderList;
}